var _effectorFileName = "/src/page-content/case-page/components/case-info/case-info.tsx";
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import type { CaseInfo } from '@/widgets/layouts/main/students-cases/constants/cases-list';
import { GradientBg } from '@/shared/components/animation/gradient-background';
import { Article } from '@/shared/components/article';
import { LineWithCircles } from '@/shared/components/line-with-circles';
import { TextGradient } from '@/shared/components/text-gradient';
interface CaseInfoProps {
  studentCaseInfo?: CaseInfo;
  studentName?: string;
}
export const Case = (props: CaseInfoProps) => {
  const {
    studentCaseInfo,
    studentName
  } = props;
  const {
    t
  } = useTranslation('cases-page');
  return <Article>
      <LineWithCircles className="sm:mx-auto sm:max-w-lg lg:max-w-2xl">
        {studentCaseInfo?.sections.map((section, index) => {
        return <div key={index} className="mb-10">
              {section.title && <TextGradient className="mb-2 text-lg sm:mb-4 sm:text-xl" tag="h2" text={`${section.title}:`} />}

              {Array.isArray(section.content) && <ul className="list-inside list-disc sm:space-y-2">
                  {section.content.map(content => <li key={content}>{content}</li>)}
                </ul>}

              {!Array.isArray(section.content) && <TextGradient className="mb-2 text-lg sm:mb-4 sm:text-xl" text={section.content} />}
            </div>;
      })}
      </LineWithCircles>

      {studentCaseInfo?.review && <div className="mt-20">
          <h2 className="mb-6 header-h2 sm:mb-10">{t('caseDetail.reviewHeading')}</h2>

          <div className="relative flex place-items-center">
            <div className="mx-auto max-w-96 overflow-hidden rounded-md">
              <Image src={studentCaseInfo?.review} height={500} width={500} priority={false} alt={studentName ? t('caseDetail.reviewImageAlt', {
            name: studentName
          }) : t('caseDetail.reviewImageAltFallback')} />
            </div>

            <GradientBg type="circle" origin="center" size={500} />
          </div>
        </div>}
    </Article>;
};